export const lockerHandler = "bbazar-locker-handler-4587548"
